import api from '../api';

export async function sendValidacao(codigoValidador, numeroSerie) {
  return api.get(`atendimento/send/validacao/${numeroSerie}/${codigoValidador}`);
}
